/** Reusable typewriter text effect — import, never remake. */

import { useCurrentFrame, interpolate } from "remotion";

interface TypeWriterProps {
  text: string;
  delay?: number;
  speed?: number;
  style?: React.CSSProperties;
}

export function TypeWriter({ text, delay = 0, speed = 2, style }: TypeWriterProps) {
  const frame = useCurrentFrame();
  const adjustedFrame = Math.max(0, frame - delay);
  const charsToShow = Math.floor(adjustedFrame / speed);
  const visibleText = text.slice(0, charsToShow);

  const cursorOpacity = interpolate(frame % 30, [0, 15, 16, 30], [1, 1, 0, 0]);

  return (
    <span style={{ fontFamily: "'JetBrains Mono', monospace", ...style }}>
      {visibleText}
      <span style={{ opacity: cursorOpacity }}>|</span>
    </span>
  );
}
